<template>
  <el-carousel height="450px" :interval="3000" arrow="always" style="border-radius: 10px;">
    <div v-for="(item, index) in bannerList" :key="index">
           <el-carousel-item>
            <img :src="item.imageUrl" style="height: 450px;" alt="">
          </el-carousel-item>
    </div>
  </el-carousel>
</template>

<script>

import {
  getByUrl
} from '@/api/api.js';

export default {
  name: "Banner",
  data() {
    return {
      bannerList: []
    }
  },
  mounted() {
    this.getBannerList()
  },
  methods: {
    getBannerList() {
      getByUrl('/web/mallBanner/list').then(res => {
        this.bannerList = res.data
        console.log(res)
      })
    },
  }
}
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
